export const productivityStatesIcons = {
  PRODUCTIVE: { color: 'green', icon: 'fa-solid fa-arrow-trend-up' },
  UNPRODUCTIVE: {
    color: 'danger',
    icon: 'fa-solid fa-arrow-trend-down'
  },
  NEUTRAL: { color: 'info', icon: 'fa-solid fa-dash' },
  AFK: { color: 'warning' }
}
